import { render, staticRenderFns } from "./InspectorButton.vue?vue&type=template&id=cebfb20a&scoped=true&"
import script from "./InspectorButton.vue?vue&type=script&lang=js&"
export * from "./InspectorButton.vue?vue&type=script&lang=js&"
import style0 from "./inspectorButton.scss?vue&type=style&index=0&id=cebfb20a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebfb20a",
  null
  
)

export default component.exports